import { render } from "./BasePillButton.vue?vue&type=template&id=28ae4154&scoped=true"
import script from "./BasePillButton.vue?vue&type=script&lang=js"
export * from "./BasePillButton.vue?vue&type=script&lang=js"

import "./BasePillButton.vue?vue&type=style&index=0&id=28ae4154&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ae4154"]])

export default __exports__